const globalHeaderAnalyticsMapper = require('./atmmapper/global-header-analytics-mapper');

function globalHeaderAnalyticsService(atm) {
    // this jQuery based solution relies tightly on the structure of the html, e.g. nested tag levels and css class names
    // therefore admittedly it is very fragile... but unfortunately there's no better solution other than this which provides
    // the most accurate information that the data analyst is after.
    //
    // when this tracking stops working the most likely fix is to make sure the selectors and the DOM traverse matches the
    // new structure of the html
    $(window).load(function() {
        // desktop nav tracking:
        $('[ui-view="header-panel"] a').click(function(e) {
            const data = {};
            const $a = $(e.currentTarget);

            if ($a.parent().is('dd-link')) {
                return;
            }

            let category
            if ($a.attr('data-analytics-event-name')) {
                category = $a.attr('data-analytics-event-name')
            } else {
                category = $a.text().trim();
            }

            if ($a.parent('li').parent('ul').parent().is('nav.nav-main')) {
                data.department = $a.find('span:not(.sr-only)').text().trim();
            } else if ($a.attr('ui-sref') && $a.attr('ui-sref').startsWith('shop.browse.department({')) {
                data.department = $a.closest('.nav-main_item').children().first().find('span:not(.sr-only)').text().trim();
                data.subdepartment = $a.text().trim();
            } else {
                data.department = $a.closest('.nav-main_item').children().first().find('span:not(.sr-only)').text().trim();
                data.subdepartment = $a.closest('ul').prev().text().trim();
                data.category = category;
            }

            atm.push(data, globalHeaderAnalyticsMapper);
        });

        // mobile nav tracking:
        $('[ui-view="mobile-nav"]').on('click', 'a', function(e) {
            const data = {};
            const $a = $(e.currentTarget);

            if ($a.parent().is('dd-link')) {
                return;
            }

            let category
            if ($a.attr('data-analytics-event-name')) {
                category = $a.attr('data-analytics-event-name')
            } else {
                category = $a.text().trim();
            }

            if ($a.is('.filters-mobile_menu_list_item_btn')) {
                data.department = $a.closest('.filters-mobile_advanced_panel').find('.filters-mobile_advanced_header_btn_text').text().trim();
                data.subdepartment = $a.text().trim();
            } else if ($a.is('.filters-mobile_menu_list_item_btn_inverse')) {
                data.department = $a.closest('.filters-mobile_advanced_panel').find('.filters-mobile_advanced_header_btn_text').text().trim();
                data.subdepartment = $a.closest('ul').prev().text().trim();
                data.category = category;
            }

            atm.push(data, globalHeaderAnalyticsMapper);
        });
    });
}

module.exports = globalHeaderAnalyticsService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/globalheader/global-header-analytics-service.js
 **/